import { gsap } from 'gsap'

const scrollTo = (selector, offset) => {
  gsap
    .timeline()
    .to(window.smoother, {
      scrollTop: window.smoother.offset(selector, offset),
      duration: 0.4,
    })
    .call(() => {
      window.smoother.scrollTrigger.refresh()
    })
}

export default scrollTo
